import { Component, Input, SimpleChanges, Output, EventEmitter, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormsModule } from '@angular/forms'; 
import { MaterialModule } from '@app/material.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CustomTableModel } from '@app/shared/models/custom-table.model';

import { MatIconModule } from '@angular/material/icon';
import { MatSelectChange } from '@angular/material/select';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { ReactiveFormsModule } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
@Component({
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
],
  selector: 'app-custom-table',
  templateUrl: './custom-table.component.html',
  styleUrls: ['./custom-table.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CustomTableComponent {
  @Input() tableData!: CustomTableModel;
  @Input() filters!: any[];
  /** Muestra la columna de checkbox (selección por `id`, como en los catálogos). */
  @Input() selectable = false;
  @Output() selectionChange = new EventEmitter<any[]>();
  selection = new SelectionModel<any>(true, [], true, (a, b) => a?.id != null && a.id === b?.id);
  /** Selección compartida con el módulo (p. ej. para marcar también desde las tarjetas). */
  @Input() set selectionModel(model: SelectionModel<any> | null | undefined) { if (model) this.selection = model; }

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  dataSource: any

  displayedColumns: any[] = []

  monthMap: Record<string, number> = {
    enero: 0, febrero: 1, marzo: 2, abril: 3, mayo: 4, junio: 5,
    julio: 6, agosto: 7, septiembre: 8, octubre: 9, noviembre: 10, diciembre: 11,
  };

  @Output() actionClicked = new EventEmitter<string>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes['tableData']) {
      console.log('tableData input changed:', this.tableData);
      this.displayedColumns = this.tableData.columns.map(c => c.columnKey as string);
      if (this.selectable) this.displayedColumns = ['select', ...this.displayedColumns];
      // Lo que ya no está en la tabla deja de estar seleccionado.
      const ids = new Set((this.tableData.data as any[]).map(r => r?.id));
      const stale = this.selection.selected.filter(r => !ids.has(r?.id));
      if (stale.length) { this.selection.deselect(...stale); this.selectionChange.emit(this.selection.selected); }
      this.dataSource = new MatTableDataSource(this.tableData.data);
      this.dataSource.paginator = this.paginator;
    }
  }

  // ── Selección ──
  private get visibleRows(): any[] { return (this.dataSource?.filteredData ?? []) as any[]; }
  isAllSelected(): boolean {
    const rows = this.visibleRows;
    return rows.length > 0 && rows.every(r => this.selection.isSelected(r));
  }
  isPartiallySelected(): boolean { return this.selection.hasValue() && !this.isAllSelected(); }
  toggleAllRows(): void {
    if (this.isAllSelected()) this.selection.deselect(...this.visibleRows);
    else this.selection.select(...this.visibleRows);
    this.selectionChange.emit(this.selection.selected);
  }
  toggleRow(row: any): void {
    this.selection.toggle(row);
    this.selectionChange.emit(this.selection.selected);
  }
  clearSelection(): void {
    this.selection.clear();
    this.selectionChange.emit([]);
  }
  openImage(url: string): void { if (url) window.open(url, '_blank'); }

  /**
   * @description Regresar las acciones del usuario al componente origen
   */
  onActionClick(content: string) {
    console.log('[onActionClick]', content);
    this.actionClicked.emit(content); // puedes emitir cualquier dato
  }

  applyFilter(event: any, type?:string, filter?:any){
    let txt = '';
    let data = this.tableData.data;

    //Si el filtro es de rango de fecha
    if(event instanceof MatDatepickerInputEvent){
      if(type === 'start')data = this.tableData.data.filter(c => (JSON.stringify(c).match(/\d{1,2} de \w+ de \d{4}, \d{1,2}:\d{2}/g) || []).some(d => (this.fixDateFormat(d) || 0) >= event.value));
      if(type === 'end')data = this.tableData.data.filter(c => (JSON.stringify(c).match(/\d{1,2} de \w+ de \d{4}, \d{1,2}:\d{2}/g) || []).some(d => event.value >= (this.fixDateFormat(d) || 0)));
      return
    }

    if (event instanceof KeyboardEvent) txt = (event.target as HTMLInputElement).value.toLowerCase(); //Txt input
    else if (event instanceof MatSelectChange){ //Select input
      if(Array.isArray(event['value'])? event['value'].includes('Todos'): event['value'] === 'Todos') this.selectAll(filter.label) //Si se selecciona 'todos'
      else if(Array.isArray(event['value'])) event['value'].forEach(v => txt += v.toLowerCase())
      else txt = event['value'].toLowerCase();
    }
    //console.log('[applyFilter] filterValue', filterValue)
    this.dataSource.filter = txt.trim().toLowerCase();
    this.dataSource.paginator = this.paginator;
  }

  selectAll(filter: any){

  }

  fixDateFormat(dateStr: string): Date | null {
    const match = dateStr.match(/(\d{1,2}) de (\w+) de (\d{4}), (\d{1,2}):(\d{2})/);
    if (!match) return null;
    const [, day, monthName, year, hours, minutes] = match;
    const month = this.monthMap[monthName.toLowerCase()];
    if (month === undefined) return null;
    return new Date(Number(year), month, Number(day), Number(hours), Number(minutes));
  }

  refresh(form: NgForm){
    this.dataSource = new MatTableDataSource(this.tableData.data);
    this.dataSource.paginator = this.paginator;
  }
}
